import { PayloadAction } from '@reduxjs/toolkit';
import { trackException } from 'app-insights/appInsightsTracking';
import { ExceptionType } from 'app/enums/Common';
import { PlacementService } from 'app/services/PlacementServices/placement-service';
import { httpSuccess } from 'app/services/serviceHelpers';
import { call, getContext, put, select } from 'redux-saga/effects';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';
import { ServiceConstants } from '../sagaHelper';
import { IPlacementSummaryRequest, placementSummaryActions } from '../slice';
import { TrackOfferConfirmationsWrapper, resetFailureStatus } from '../saga';
import InitPlacementSummary, { IConsolidatedRequirementResponse } from '../init.types';
import { selectPlacementConsolidatedDetails } from '../consolidatedStoreSelectors';

export function* requestOfferConfirmationRequirement(action: PayloadAction<IPlacementSummaryRequest>) {
  try {
    yield put(resetFailureStatus('offerConfirmationRequirement'));

    const placementService: PlacementService = yield getContext('placementService');

    let response;

    const consolidatedDetails = yield select(selectPlacementConsolidatedDetails);
    if(action.payload.isInitLoad && consolidatedDetails){
      response = {
        status : 200,
        data :{
          offerConfirmations : {
            dnsCleared : consolidatedDetails.summary.offer.offerConfirmationRequrement?.dnsCleared?.data,
            datesConfirmed : consolidatedDetails.summary.offer.offerConfirmationRequrement?.datesConfirmed?.data,
            travelConfirmed : consolidatedDetails.summary.offer.offerConfirmationRequrement?.travelConfirmed?.data,
            nextStatusRequirement : consolidatedDetails.summary.offer.offerConfirmationRequrement?.nextStatusRequirement,
          } 
        } 
      }
    }
    
    if(!response){
      response = yield call(
        TrackOfferConfirmationsWrapper,
        placementService.getStrikeRequirementsByContainer,
        action.payload.placementId,
        ...ServiceConstants.offerConfirmation,
      );
    }
    
    if (httpSuccess(response?.status)) {
      yield put(placementSummaryActions.setOfferConfirmationInfo(response.data.offerConfirmations));
      yield put(placementDetailsAction.resetForm());
    } else {
      yield put(
        placementSummaryActions.setServiceFailureByKey({ key: 'offerConfirmationRequirement', failureStatus: true }),
      );
    }
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        name: ExceptionType.APIRequestError,
        functionName: 'requestOfferConfirmationRequirement',
        area: 'src/store/redux-store/placement-summary/common-saga/requestOfferConfirmationRequirement.ts',
      },
    });
  }
}

export function processOfferConfirmationRequirement(
  response: IConsolidatedRequirementResponse<any>,
  context: InitPlacementSummary,
) {
  try {
    if (!httpSuccess(response?.status)) {
      context.setServiceFailureByKey({ key: 'offerConfirmationRequirement', failureStatus: true });
      return;
    }
    context.setOfferConfirmationInfo(response.data);
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        name: ExceptionType.CommonSAGAError,
        functionName: 'processOfferConfirmationRequirement',
        area: 'src/store/redux-store/placement-summary/common-saga/requestOfferConfirmationRequirement.ts',
      },
    });
  }
}
